export const doLogout = () => ({
    type: 'DO_LOGOUT',
    payload: true
});

export const setUser = user => ({
    type: 'SET_USER',
    payload: user
});

export const decodeJWTToken = jwtToken => ({
    type: 'DECODE_JWT_TOKEN',
    payload: jwtToken
});

export const setIsLoggedIn = isLoggedIn => ({
    type: 'SET_LOGGED_IN',
    payload: isLoggedIn
});